<template>
    <div class="topbar d-none d-lg-block">
        <div class="container">
            <div class="text-center">
                <p>
                    Introducing Chat by tech.ai: Whatever you need, just ask it.
                    <router-link to="/about">learn more</router-link>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TopHeader",
    }
</script>


// WEBPACK FOOTER //
// src/components/page_components/home-5/TopHeader.vue